import styled from 'styled-components';

const StyledScrollingVideos = styled.div`
  position: relative;
  width: 100%;
  .videos-scroller{
    position: relative;
    width: 100%;
    height: auto;
  }
  .first--slide{
    background-color: black;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
  }
  .first--slide,
  .video--slide{
    position: relative;
    width: 100%;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    background-color: black;
    overflow: hidden;
  }
  .video-wrap{
    position:relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .video-wrap--mask{
    position:relative;
    overflow: hidden;
    width: 50%;
    height: 50%;
  }
  .over-video{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    background-color: rgba(0,0,0,.4);
  }
  .video-wrap video{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: auto;
    transform: translate(-50%,-50%);
    z-index: 1;
    background-size: cover;
  }
  .video--slide h5{
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
    transform: translate(-50%,-50%);
    text-align: center;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    .video--slide{
      height: calc(var(--vh, 1vh) * 45);
    }
    
  }
  @media screen and (max-width: 767px){
    .video-wrap video{
      width: 100vw
    }
  }
`;

export {
  StyledScrollingVideos,
};

